import React, { Component } from "react";
import { Row, Col, Form, Button, Spinner, Alert, Container } from "react-bootstrap";
import "../assets/style/login.css";
import { submitSignup } from "../includes/Helper";
import auth from "../Auth";

class Signup extends Component {
  state = {
    logingin: false,
    isInvalidLogin: -1,
    invalidLoginMessage: "",
  };

  constructor() {
    super();
    this.handleSignup = this.handleSignup.bind(this);
  }

  async handleSignup(event) {
    event.preventDefault();
    const first_name = event.target.elements.first_name.value;
    const last_name = event.target.elements.last_name.value;
    const user_email = event.target.elements.user_email.value;
    const user_password = event.target.elements.user_password.value;
    const user_password_2 = event.target.elements.user_password_2.value;

    if (user_password !== user_password_2) {
      this.setState({ isInvalidLogin: 1, invalidLoginMessage: "Passwords do not match" });
      return;
    } else {
      this.setState({ logingin: true });
      const response = await submitSignup(first_name, last_name, user_email, user_password);
      this.setState({ logingin: false });

      console.log(`LOLLLLL`, response);

      if (response.status === false) {
        this.setState({ isInvalidLogin: 1, invalidLoginMessage: response.error });
      } else {
        auth.login(response, () => {
          this.props.history.push("home");
        });
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <Container fluid={true}>
          <Row style={{ paddingBottom: "50px" }}>
            <Col md={12}>
              <div className="div-form-container">
                <div style={{ borderBottom: "1px solid #ddd", paddingBottom: "20px" }}>
                  <h2>FBA Inventory Eliminator</h2>
                  <p>Remove unprofitable books from Amazon’s warehouse to free up space for fresh inventory.</p>
                  <h3>Create a new Account</h3>
                </div>

                {this.state.isInvalidLogin === 1 && (
                  <div style={{ marginTop: "20px" }}>
                    <Alert variant="danger">
                      <span>{this.state.invalidLoginMessage}</span>
                    </Alert>
                  </div>
                )}
                <div style={{ marginTop: "35px" }}>
                  <Form onSubmit={this.handleSignup}>
                    <Form.Group controlId="formBasicEmail">
                      <Form.Control
                        style={{ textAlign: "center" }}
                        type="text"
                        name="first_name"
                        placeholder="First Name"
                      />
                    </Form.Group>
                    <Form.Group controlId="formBasicEmail">
                      <Form.Control
                        style={{ textAlign: "center" }}
                        type="text"
                        name="last_name"
                        placeholder="Last Name"
                      />
                    </Form.Group>
                    <Form.Group controlId="formBasicEmail">
                      <Form.Control
                        style={{ textAlign: "center" }}
                        type="text"
                        name="user_email"
                        placeholder="Enter email"
                      />
                    </Form.Group>

                    <Form.Group style={{ marginTop: "30px" }} controlId="formBasicPassword">
                      <Form.Control
                        style={{ textAlign: "center" }}
                        type="password"
                        name="user_password"
                        placeholder="Password"
                      />
                    </Form.Group>
                    <Form.Group style={{ marginTop: "30px" }} controlId="formBasicPassword">
                      <Form.Control
                        style={{ textAlign: "center" }}
                        type="password"
                        name="user_password_2"
                        placeholder="Password"
                      />
                    </Form.Group>

                    {this.state.logingin ? (
                      <Spinner style={{ marginTop: "33px" }} animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                      </Spinner>
                    ) : (
                      <Button variant="primary" type="submit" style={{ marginTop: "30px" }}>
                        Submit
                      </Button>
                    )}
                  </Form>
                </div>

                <div style={{ marginTop: "20px" }}>
                  <Button variant="link" onClick={() => this.props.history.push("/")}>
                    Already have an account? Click here to login
                  </Button>
                </div>

                <div style={{ marginTop: "20px" }}>
                  Questions? Email <a href="mailto:caleb@thebookflipper.com">caleb@thebookflipper.com</a>
                </div>

                <div style={{ marginTop: "30px", borderTop: "1px solid #ddd", paddingTop: "10px" }}>
                  <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/watch?v=dDg2ObHuJC0">
                    * Click here to see how to use this free tool *
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default Signup;
